<template>
  <div class="twitter-analytics-public-header">
    <div class="custom-title" layout layout-align="start-center">
      <el-tooltip :content="campaign.account.name">
        <Icon
          class="mr-x1"
          :picture-url="campaign.account.pictureUrl"
          :name="campaign.account.name"
          :icon-type="campaign.targetSns"
        ></Icon>
      </el-tooltip>
      <div>{{ campaign.title }}</div>
    </div>
    <div class="mt-x1">
      期間: {{ formatDatetime(campaign.startDatetime) }} 〜 {{ formatDatetime(campaign.endDatetime) }}
    </div>
    <div v-if="isCampaignCollectionCompleted">
      <div class="mt-x1">
        <div class="message message-info">分析データの最終集計が完了しました。</div>
      </div>
    </div>
    <div v-else-if="isCampaignFinalCollection">
      <div class="mt-x1">
        <div class="message message-info">
          分析データの最終集計中です。<br />{{ collectCompletedAt }}
          ごろまでに最終的なデータが反映されます。応募件数により、反映が遅れる場合があります。
        </div>
      </div>
    </div>
    <div v-else-if="isRepostCampaignBeforeCollect">
      <div class="mt-x1">
        <div class="message message-info">
          応募収集URLを設定すると、応募の収集を開始します。設定されるまで応募は収集されません。<br />応募は30分間隔で収集されます。URLの設定時点から7日より前の応募は収集されないため、早めに設定してください。
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import { CAMPAIGN_STATUS } from '@/client/constant'
import {
  RepostCollectionAlertState,
  resolveRepostCollectionAlertState
} from '@/client/features/campaigns/utils/repostCollectionAlert'
import { formatDatetime } from '@/client/filters/filters'
import { useTwitterAnalyticsPublicStore } from '@/client/store/useTwitterAnalyticsPublicStore'

export default defineComponent({
  components: { Icon },
  computed: {
    ...mapState(useTwitterAnalyticsPublicStore, {
      campaign(state) {
        const campaign = { ...state.campaign }

        if (!campaign.account || !campaign.account.name) {
          campaign.account = {
            name: '削除されたアカウント',
            pictureUrl: require('@/client/assets/images/twitter_default_profile.png')
          }
        }

        return campaign
      }
    }),

    repostCollectionAlertState() {
      return resolveRepostCollectionAlertState({
        type: this.campaign.type,
        entryActionType: this.campaign.entryActionType,
        status: this.campaign.status,
        hasTweetPostUrl: Boolean(this.campaign.hasTweetPostUrl)
      })
    },

    isRepostCampaignBeforeCollect() {
      return this.repostCollectionAlertState === RepostCollectionAlertState.BEFORE_COLLECTION
    },

    isCampaignFinalCollection() {
      return this.campaign.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION
    },

    isCampaignCollectionCompleted() {
      return this.campaign.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED
    },

    collectCompletedAt() {
      // フォロワー取得バッチが深夜1時に実行されるため、次のバッチ実行日の午前10時を表示する
      return moment(this.campaign.endDatetime).subtract(1, 'hours').add(1, 'days').format('YYYY年MM月DD日 10:00')
    }
  },
  methods: {
    formatDatetime
  }
})
</script>
